import { render, staticRenderFns } from "./DefaultGenreAndRegion.vue?vue&type=template&id=2637ce2c&"
import script from "./DefaultGenreAndRegion.vue?vue&type=script&lang=js&"
export * from "./DefaultGenreAndRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports